import { render, staticRenderFns } from "./OrgConversionRates.vue?vue&type=template&id=7666a1ba&scoped=true&"
import script from "./OrgConversionRates.vue?vue&type=script&lang=js&"
export * from "./OrgConversionRates.vue?vue&type=script&lang=js&"
import style0 from "./OrgConversionRates.vue?vue&type=style&index=0&id=7666a1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7666a1ba",
  null
  
)

export default component.exports